import { Injectable } from '@angular/core';
import { NotificationService } from './core.notification.service';

@Injectable()
export class DragNotificationService {
    private dragTimer: any;
    private isDraggingOver = false;
    private listenersAttached = false;
    private listenerRefCount = 0;

    private handleDragOver = (e: DragEvent) => {
        if (this.dragTimer) {
            window.clearTimeout(this.dragTimer);
        }

        if (!this.isDraggingOver) {
            this.notificationService.notifyAll('DRAGOVER_START_EVENT', {});
            this.isDraggingOver = true;
        }

        this.dragTimer = window.setTimeout(() => {
            this.notificationService.notifyAll('DRAGOVER_END_EVENT', {});
            this.isDraggingOver = false;
            this.dragTimer = null;
        }, 200);

        e.preventDefault();
        e.stopPropagation();
    };

    private handleDragLeave = (e: DragEvent) => {
        if (e.target === document || e.target === document.documentElement) {
            if (this.dragTimer) {
                window.clearTimeout(this.dragTimer);
            }

            if (this.isDraggingOver) {
                this.notificationService.notifyAll('DRAGOVER_END_EVENT', {});
                this.isDraggingOver = false;
                this.dragTimer = null;
            }
        }
    };

    private handleDrop = (e: DragEvent) => {
        if (this.dragTimer) {
            window.clearTimeout(this.dragTimer);
            this.dragTimer = null;
        }

        if (this.isDraggingOver) {
            this.notificationService.notifyAll('DRAGOVER_END_EVENT', {});
            this.isDraggingOver = false;
        }

        e.preventDefault();
    };

    constructor(private notificationService: NotificationService) {}

    /**
     * Initialize drag and drop event listeners for the entire application.
     * Provides global drag start/end notifications.
     */
    initializeDragListeners(): void {
        if (typeof window === 'undefined') {
            return;
        }

        this.listenerRefCount++;

        if (this.listenersAttached) {
            return;
        }

        window.addEventListener('dragover', this.handleDragOver);
        window.addEventListener('dragleave', this.handleDragLeave);
        window.addEventListener('drop', this.handleDrop, true);
        this.listenersAttached = true;
    }

    /**
     * Cleanup method for destroying event listeners
     */
    destroy(): void {
        if (this.dragTimer) {
            window.clearTimeout(this.dragTimer);
        }

        if (this.listenerRefCount > 0) {
            this.listenerRefCount--;
        }

        if (this.listenerRefCount === 0 && this.listenersAttached && typeof window !== 'undefined') {
            window.removeEventListener('dragover', this.handleDragOver);
            window.removeEventListener('dragleave', this.handleDragLeave);
            window.removeEventListener('drop', this.handleDrop, true);
            this.listenersAttached = false;
        }
    }
}
